import React from 'react'
import ImageGridPrivate from '../../Media/ImageGridPrivate'
import UploadForm from '../../Media/UploadForm'
import UploadFormPrivate from '../../Media/UploadFormPrivate'

function AddProfileImage({authorId, setProfileImage}) {

    return (

        <div>
            <h5 className="font-weight-bold">Last opp bilde</h5>
            <UploadFormPrivate authorId={authorId} setProfileImage={setProfileImage} />
            <hr />
            <h5 className="font-weight-bold">Velg fra galleri</h5>
            <ImageGridPrivate authorId={authorId} setProfileImage={setProfileImage} />
        </div>

    )
}
export default AddProfileImage